export default __webpack_public_path__ + "static/media/02.54f54ba8.png";